export enum AuthorizationState {
    authorized = 'authorized',
    forbidden = 'forbidden',
    unauthorized = 'unauthorized'
}
